import { RootAction } from '@src/app/_redux';
import { UNAUTH_IAM_KEYS_SUCCESS, AUTH_IAM_KEYS_SUCCESS } from '@src/app/login/weak/actions';
import { combineReducers } from 'redux';

export type State = {
  identityId: string;
  credentials: any;
};

export const reducer = combineReducers<State, RootAction>({
  identityId: (state = '', action) => {
    switch (action.type) {
      case UNAUTH_IAM_KEYS_SUCCESS:
        return action.payload.identityId;
      default:
        return state;
    }
  },
  credentials: (state = '', action) => {
    switch (action.type) {
      case AUTH_IAM_KEYS_SUCCESS:
        return action.payload.credentials;
      default:
        return state;
    }
  },
});
